import React, { forwardRef, useState } from "react";
import { Input, Modal } from "antd";
import styles from "./index.module.scss";

interface DataModalInstance {}
interface DataModalProps {
    onOk: (data: string) => void;
}

const RoomModal = forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, ...props }, ref) => {
        const [data, setData] = useState("");
        return (
            <Modal
                {...props}
                centered
                width={600}
                className={styles.root}
                onOk={() => onOk(data)}
                title="维护腾讯会议考场信息">
                <div style={{ padding: 30 }}>
                    <Input.TextArea
                        value={data}
                        rows={5}
                        onChange={e => setData(e.target.value)}
                    />
                </div>
            </Modal>
        );
    }
);

export default RoomModal;
